import create from 'zustand';

export const useCashMovementsStore = create((set) => ({
  cashMovements: false,

  setCashMovements: (useCashMovements) =>
    set(() => ({
      cashMovements: useCashMovements,
    })),
}));
